<template>
	<v-container class="maxw-40 px-0">
		<v-card class="pa-5">
			<v-form v-model="formIsValid">
				<v-text-field
					label="Email"
					type="text"
					class="form-control"
					:rules="emailValidationRules"
					validate-on-blur
					v-model="formValue.email"
				/>
				<v-text-field
					label="Password"
					:type="passwordInputType"
					class="form-control"
					v-model="formValue.password"
					:append-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
					@click:append="showPasswords = !showPasswords"
				/>
				<div class="d-flex justify-space-between align-center">
					<router-link :to="{ name: 'auth-forgot-password', query: { email: formValue.email } }"
						>Forgot password?</router-link
					>
					<v-btn rounded type="submit" @click.prevent="submit" color="primary">Login</v-btn>
				</div>
			</v-form>

			<div class="text-center text-muted mt-5">
				Don't have an account?
				<router-link :to="registerLink">Register now</router-link>
			</div>
		</v-card>

		<transition name="fade">
			<app-feedback v-if="errorMessage" class="mt-5" @closed="errorMessage = ''">{{ errorMessage }}</app-feedback>
		</transition>
	</v-container>
</template>

<script>
import appFeedback from '@/components/common/Feedback.vue';
import soilApiService from '../../services/soilApiService';
import { emailValidationRules } from '../../utils/rules';

export default {
	components: {
		appFeedback,
	},
	props: {
		redirect: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			formIsValid: true,
			errorMessage: '',
			showPasswords: false,
			formValue: {
				email: '',
				password: '',
			},
			emailValidationRules,
		};
	},
	computed: {
		passwordInputType() {
			return this.showPasswords ? 'text' : 'password';
		},
		registerLink() {
			const link = {
				name: 'auth-register',
				params: {},
			};

			if (this.redirect) {
				link.params.redirect = this.redirect;
			}

			return link;
		},
	},
	async created() {
		if (this.$route?.query?.email) {
			this.formValue.email = this.$route.query.email;
		}
	},
	methods: {
		async submit() {
			if (!this.formIsValid) {
				return;
			}

			if (this.formValue.password.trim() === '') {
				this.errorMessage = 'You must enter a password.';
				return;
			}

			try {
				await soilApiService.login({
					email: this.formValue.email.trim(),
					password: this.formValue.password.trim(),
				});

				this.$router.push(this.redirect || '/');
			} catch (error) {
				if (error?.response?.status === 401) {
					this.errorMessage = 'Invalid email or password.';
					return;
				}
				this.errorMessage = 'An error has occurred. Please try again.';
			}
		},
	},
};
</script>

<style scoped>
a {
	text-decoration: none;
}
</style>
